import React, { useState } from 'react';

import Text from 'components/Text';
import { Button } from 'components/Button';
import { Row } from 'components/Layout/Grid';
import Input from 'components/Input';
import Login from '..';
import { PageViewTracker } from 'components/ApplicationInsights/pageViewTracker';

import UserService from 'services/user.service';

import IconInputManUser from 'img/input-man-user.svg';
import IconArrowLeft from 'img/arrow-left.svg';
import IconNewPassword from 'img/request-new-password-success.svg';


const ForgotPassword: React.FC = () => {
  const [emailInput, setEmailInput] = useState('');

  const _userService = new UserService();
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const makeRequestOnEnterPress = (e: any) => {
    if (e.keyCode !== 13) return;
    return userRequestNewPassword();
  };

  async function userRequestNewPassword() {
    setLoading(true);
    setSuccess(false);
    setErrorMessage('');
    _userService
      .resetPassword(emailInput)
      .then(() => setSuccess(true))
      .catch((err) => {
        setLoading(false);
        setErrorMessage(
          err?.response?.data?.data || 'Erro ao realizar requisição'
        );
      });
  }

  return (
    <Login>
      <PageViewTracker />
      {!success ? (
        <div className="animated fadeIn">
          <Text size={24} className="color-primary font-bold">
            Esqueci minha senha
          </Text>
          <Text className="color-blue-gray text-wrap mt-2" size={14}>
            Informe seu e-mail no campo abaixo que iremos enviar as instruções
            para recuperação do seu acesso. Caso não se recorde do e-mail
            utilizado, entre em contato com o SAC através do 0800 701 3080.
          </Text>
          <div className="flex-col relative">
            <Input
              disabled={loading}
              onKeyDown={(e: any) => makeRequestOnEnterPress(e)}
              onChange={(e: any) => setEmailInput(e.target.value)}
              value={emailInput}
              type="email"
              required
              icon={IconInputManUser}
              iconStyle={{ right: 2, bottom: 10, borderRadius: 6 }}
              placeholder="E-mail"
              spellCheck="false"
              autoFocus
              className="w-100 mt-2"
            />
            {errorMessage && (
              <Text className="color-danger mt-2 animated fadeIn" size={14}>
                {errorMessage}
              </Text>
            )}
            <div className="d-flex justify-between align-center mt-3">
              <button
                // eslint-disable-next-line no-return-assign
                onClick={() => (window.location.href = '/')}
                className="no-style inline-flex"
              >
                <img src={IconArrowLeft} alt="" />
                <Text className="ml-2" size={14}>
                  Retornar
                </Text>
              </button>
              <Button
                className="w-md-60 action-button"
                isRequesting={loading}
                disabled={loading}
                onClick={userRequestNewPassword}
                width={105}
              >
                <Text className="color-white">Solicitar</Text>
              </Button>
            </div>
          </div>
        </div>
      ) : (
        <div className="animated fadeIn my-5">
          <Row className="animated fadeIn justify-center align-center">
            <img
              src={IconNewPassword}
              alt=""
              style={{ height: 96, width: 96 }}
            />
          </Row>
          <Text size={14} className="color-blue-gray text-wrap mt-5 px-4">
            Foi enviado para o email <b>{emailInput}</b> um link para que você
            redefina a senha do acesso.
          </Text>
          <a href="/" className="no-style d-flex align-center mt-5">
            <img src={IconArrowLeft} alt="" />
            <Text className="ml-2" size={14}>
              Retornar
            </Text>
          </a>
        </div>
      )}
    </Login>
  );
};

export default ForgotPassword;
